import React from "react";
import GlobalFatalError from "./GlobalFatalError";
function isResolversError(err) {
  if (!err) return false;
  const msg = String(err.message || err);
  return /withResolvers/i.test(msg) || /Promise\.withResolvers/i.test(msg);
}

export default class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
    this.reset = this.reset.bind(this);
  }

  componentDidCatch(error, errorInfo) {
    // 捕获渲染期异常
    this.setState({ error, errorInfo });
  }

  componentDidMount() {
    // 监听未捕获异常和未处理的 Promise 拒绝
    this._onError = (event) => {
      if (event?.error) {
        this.setState({ error: event.error, errorInfo: { componentStack: "" } });
      }
    };
    this._onUnhandledRejection = (event) => {
      const reason = event?.reason;
      if (reason instanceof Error) {
        this.setState({ error: reason, errorInfo: { componentStack: "" } });
      } else if (reason) {
        this.setState({ error: new Error(String(reason)), errorInfo: { componentStack: "" } });
      }
    };

    window.addEventListener("error", this._onError);
    window.addEventListener("unhandledrejection", this._onUnhandledRejection);
  }

  componentWillUnmount() {
    window.removeEventListener("error", this._onError);
    window.removeEventListener("unhandledrejection", this._onUnhandledRejection);
  }

  reset() {
    // 你可以自定义为路由跳转、刷新等
    window.location.reload();
  }

  render() {
    const { error, errorInfo } = this.state;

    const hasError = !!error;
     // ✅ 错误时占满整行（把后面的文件名挤到下一行）
    const wrapperStyle = hasError ? { flexBasis: "100%", width: "100%" } : { flex: "0 0 auto" };

    if (error && isResolversError(error)) {
      return <div style={wrapperStyle}>
      <GlobalFatalError error={error} errorInfo={errorInfo} reset={this.reset} />
    </div>
     
    }
    // 非 withResolvers 错误 => 交给子组件决定，或也可一并显示 GlobalFatalError
    if (error) {
     return  <div style={wrapperStyle}>
        <GlobalFatalError error={error} errorInfo={errorInfo} reset={this.reset} />
      </div>;
    }
    return this.props.children;
  }
}
